import { createContext, useCallback, useContext, useMemo, useState } from "react";
import ReferralOverlay from "../components/referral/ReferralOverlay";

const ReferralOverlayContext = createContext(null);

export function ReferralOverlayProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openReferral = useCallback(() => setOpen(true), []);
  const closeReferral = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ open, openReferral, closeReferral }),
    [open, openReferral, closeReferral]
  );

  return (
    <ReferralOverlayContext.Provider value={value}>
      {children}
      <ReferralOverlay open={open} onClose={closeReferral} />
    </ReferralOverlayContext.Provider>
  );
}

export function useReferralOverlay() {
  const ctx = useContext(ReferralOverlayContext);
  if (!ctx) {
    throw new Error("useReferralOverlay must be used within ReferralOverlayProvider");
  }
  return ctx;
}
